module.exports = __webpack_public_path__ + "img/floor_installation.b807a035.png";